<script lang="ts">
	import { ShopBookPdp } from '#lib/websites/shop/pages/ShopBookPdp/index.js';
</script>

<ShopBookPdp />
